import { WithFetchDatasByIdFromCMS } from 'modules/shared-cms/hocs';

import { QUERY } from './mention-query';
import { MentionLoader } from './mention-component-loader';
import { MentionProps } from './mention-type';

const enhancer = WithFetchDatasByIdFromCMS<MentionProps>(QUERY, MentionLoader, 'findMentionContent');
export default enhancer;
